import React, { useEffect, useState } from 'react'
import Popup from 'reactjs-popup'
import Button from '../Button'
import ProgressCircle from '../ProgressCircle'
import ActivityIndicator from './ActivityIndicator'
import CircularCloseButton from '../CircularCloseButton'
import ButtonSpinner from './ButtonSpinner'
import(/* webpackPreload: true */'reactjs-popup/dist/index.css')

export default (props) => {
  const {
    ref,
    visible,
    title,
    renderContent,
    onPressClose,
    resetPagesOnClose,
    closeOnDocumentClick,
    options,
    idName,
    backgroundColor = 'blue',
    width,
    hideCloseButton = false,
    isInsuredVehicles = false,
    className,
    lockScroll = false,
  } = props

  const [currentPage, setCurrentPage] = useState(0)
  const [isFormLoading, setIsFormLoading] = useState(false)
  const isContentInArray = renderContent && (renderContent instanceof Array)

  const navigateToPage = async (increment) => {
    if (Math.sign(increment) === 1) {
      if (currentPage < (renderContent.length - 1) && setCurrentPage ) { return setCurrentPage(currentPage + increment) }
      if (
          (currentPage === (renderContent.length - 1)) && 
          renderContent[currentPage] &&
          renderContent[currentPage].onPressSubmit
        ){
          setIsFormLoading(true)
          await renderContent[currentPage].onPressSubmit()
          resetPagesOnClose && setCurrentPage(0)
          setIsFormLoading(false)
          return
      }
    }
    if (Math.sign(increment) === -1) {
      if (currentPage > 0 && setCurrentPage){ return setCurrentPage(currentPage + increment) }
      if (currentPage === 0 && onPressClose){ return onPressClose() }
    }
  }

  return (
    <Popup lockScroll={lockScroll} className={`popup-${backgroundColor} ${width ? `popup-${width}` : ''} ${isInsuredVehicles ? 'popup-insured' : ''} ${className ?? ''}`} closeOnEscape={false} ref={ref} open={visible} closeOnDocumentClick={closeOnDocumentClick || false}>
      <div className="content-box content-box-is-padding-small content-box--is-no-margin">
        <div className="form-header-content-wrapper">
          {
            isContentInArray ? <ProgressCircle style={isContentInArray ? {marginRight: 10} : {}} currentStep={currentPage + 1} totalSteps={renderContent.length} percent={100} /> : null
          }
          <h1 className="popup-header-main">{title}</h1>
          {!hideCloseButton && (
            <CircularCloseButton
              onClick={() => {
                resetPagesOnClose && setCurrentPage(0)
                onPressClose()
              }}
              top={20}
              right={ isInsuredVehicles ? 10 : 20 }
            />
          )}
        </div>
        {title ? <hr className="content-box__section-divider"></hr> : null }
        {
          isContentInArray ?
          <div>
            { renderContent[currentPage].render() }
            <div className="form-button-wrapper">
              <Button
                title={'Back'}
                color={'transparent'}
                disabled={false}
                idName={'motor-vehicle-details-owner-cancel-button'}
                onClick={() => navigateToPage(-1)}
              />
              
              <ButtonSpinner
                title={currentPage === (renderContent.length - 1) ? 'Submit' : 'Proceed'}
                color={'#68C9D0'}
                disabled={!renderContent[currentPage].canProceed}
                idName={'motor-vehicle-details-owner-proceed-button'}
                onClick={async () =>{
                  setIsFormLoading(true)
                  const error =
                    renderContent[currentPage].onPressProceed &&
                    (await renderContent[currentPage].onPressProceed()); 
                  setIsFormLoading(false)
                  !error && navigateToPage(+1)
                }}
                isLoading={isFormLoading}
              />
            </div>
          </div>
            :
          renderContent()
        }
      </div>
      {options && options.show && <div style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between' }} className="content-box content-box-is-padding-small content-box--is-no-margin">
        <div className="popup-button-wrapper">
          {Object.values(options.options).map((option, index) => {
            return (<Button
              key={index}
              title={option.title}
              color={!index ? '#68C9D0' : 'transparent'}
              onClick={() => option.function()}
              idName={ (idName && option.title) 
                ? `${idName}-${[option.title].toString().trim().toLowerCase().split(' ').join('-')}`
                : idName ? `${idName}-button`
                : ''
              } 
            />)
          })}
        </div>
      </div>}
    </Popup>
  )
}
